import {
    GET_LIST_RELATIONSHIP_TYPES,
    UPDATE_SPECIFIC_RELATIONSHIP_TYPES,
    CREATE_NEW_RELATIONSHIP_TYPES,
    REMOVE_RELATIONSHIP_TYPES,
    GET_RELATIONSHIP_TYPES_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    relationship_types: [],
    relationshipTypeActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_RELATIONSHIP_TYPES: {
            return {
                ...state,
                relationship_types: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_RELATIONSHIP_TYPES_ACTIVE: {
            return {
                ...state,
                relationshipTypeActiveList: action.payload.data,
            }
        }

        case REMOVE_RELATIONSHIP_TYPES: {
            let temp = state.relationship_types.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.relationshipTypeActiveList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, relationship_types: temp, relationshipTypeActiveList: temp2 }
        }
        default: return { ...state };
    }
}
